import React from 'react';

import styles from './SectionContentsBody.module.scss';
import SectionContentsBodyHeader from './SectionContentsBodyHeader';

function SectionContentsBody({children, ...rest}) {
  return (
    <div className={styles['content']}>
      <SectionContentsBodyHeader {...rest} />
      {children && <div className={styles['content--body']}>{children}</div>}
    </div>
  );
}

export default SectionContentsBody;
